import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode } from "swiper/modules";

import Card from "../../Card/Card";
import Container from "../../Container/Container";
import IconBox from "../../IconBox/IconBox";
import SectionTitle from "../../SectionTitle/SectionTitle";
import { getIcon } from "../../../Utils/iconMap";
import { industries } from "../../../Data/industriesData";

import "swiper/css";
import "swiper/css/free-mode";
import "../../../Style/home/industries.css";

/** Horizontal, draggable industry carousel — hover reveals the description. */
function Industries() {
  return (
    <section id="industries" className="section section--tint industries">
      <Container>
        <SectionTitle
          eyebrow="Industries We Serve"
          title="Built for your"
          highlight="industry."
          description="The same disciplined data process, tuned to what matters in your sector."
        />
      </Container>

      <div className="industries__track">
        <Swiper
          modules={[FreeMode, Autoplay]}
          slidesPerView="auto"
          spaceBetween={20}
          freeMode
          grabCursor
          autoplay={{ delay: 2800, disableOnInteraction: true }}
          className="industries__swiper"
        >
          {industries.map((industry) => (
            <SwiperSlide key={industry.id} className="industries__slide">
              <Card interactive gradientBorder className="industries__card">
                <IconBox icon={getIcon(industry.icon)} />
                <h3 className="card__title mt-5">{industry.name}</h3>
                <p className="card__text">{industry.text}</p>
              </Card>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}

export default Industries;
